import { defineMessages } from 'react-intl';

export default defineMessages({
  addShopperButtonText: {
    description: 'Text for the button to add a new rate shopper',
    defaultMessage: 'Create New',
    id: 'Yj0OFJ',
  },
});
